export default "__VITE_ASSET__3dd85a9b__"